import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Grid } from '@mui/material';
import { BackdropWrapper } from './BackdropStyles';

const CustomBackdrop = ({ message }) => {
  return (
    <BackdropWrapper open={true}>
      <Grid container>
        <Grid item container xs={12} justifyContent='center'>
          <CircularProgress color='inherit' />
        </Grid>
        <Grid item container xs={12} justifyContent='center'>
          {message}
        </Grid>
      </Grid>
    </BackdropWrapper>
  );
};

CustomBackdrop.propTypes = {
  message: PropTypes.string
};

export default CustomBackdrop;
